module.exports = __webpack_public_path__ + "img/org-review-bad.b35df6bb.svg";